import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto" }
const _hoisted_2 = { class: "grid place-items-center lg:max-w-screen-xl gap-8 mx-auto py-20 md:py-32" }
const _hoisted_3 = { class: "text-center space-y-8" }
const _hoisted_4 = { class: "mr-2 text-white" }
const _hoisted_5 = { class: "space-y-4 flex flex-col items-center" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-green-600 bg-green-50 border border-green-200 rounded px-4 py-2 w-11/12 md:w-3/4 mx-auto"
}

import { useColorMode } from "@vueuse/core";
import { useRouter } from "vue-router";
import { ref } from 'vue';

import { Badge } from "@/components/landingPage/ui/badge";
import { Button } from "@/components/landingPage/ui/button";
import { ArrowRight } from "lucide-vue-next";


export default /*@__PURE__*/_defineComponent({
  __name: 'Hero',
  setup(__props) {

const mode = useColorMode();
const router = useRouter();

const goToUserTypeSelection = () => {
  router.push('/commencer');
};

const email = ref('');
const interestType = ref('young_person');
const successMessage = ref('');
const submitEmail = async () => {
  try {
    const API_URL = process.env.VUE_APP_SERVER_URL || 'http://localhost:5000';
    const response = await fetch(`${API_URL}/subscribe/email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email.value,
        interest_type: interestType.value,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    successMessage.value = "Votre email a bien été enregistré pour être prévenu du lancement.";
    email.value = '';
  } catch (error) {
    console.error('Subscription error:', error);
    successMessage.value = "Une erreur est survenue. Veuillez réessayer.";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Badge), {
          variant: "outline",
          class: "text-sm py-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_unref(Badge), null, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Nouveau")
                ])),
                _: 1
              })
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("span", null, " Plateforme inclusive d'orientation professionnelle ", -1))
          ]),
          _: 1
        }),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "max-w-screen-md mx-auto text-center text-5xl md:text-6xl font-bold" }, [
          _createElementVNode("h1", null, [
            _createTextVNode(" Votre singularité est une "),
            _createElementVNode("span", { class: "text-transparent bg-gradient-to-r from-[#D247BF] to-[#ff9500] bg-clip-text" }, "force ")
          ])
        ], -1)),
        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "max-w-screen-sm mx-auto text-xl text-muted-foreground" }, " Autrement Capable aide les personnes neurodivergentes (TSA) à découvrir leurs forces, construire leur projet professionnel et s'intégrer dans le monde du travail. Transformons votre singularité en opportunité. ", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(submitEmail, ["prevent"]),
            class: "flex flex-col md:flex-row items-center gap-2 w-11/12 md:w-3/4 mx-auto"
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              type: "email",
              required: "",
              placeholder: "Votre email",
              class: "border rounded px-4 py-3 text-lg w-full"
            }, null, 512), [
              [_vModelText, email.value]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((interestType).value = $event)),
              class: "border rounded px-4 py-3 text-lg"
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("option", { value: "young_person" }, "Jeune", -1),
              _createElementVNode("option", { value: "accompaneur" }, "Accompagnateur", -1)
            ]), 512), [
              [_vModelSelect, interestType.value]
            ]),
            _createVNode(_unref(Button), {
              type: "submit",
              class: "font-bold"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Être prévenu du lancement")
              ])),
              _: 1
            })
          ], 32),
          (successMessage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(successMessage.value), 1))
            : _createCommentVNode("", true),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-xs mt-2 text-gray-500" }, "En vous inscrivant, vous serez prévenu du lancement de la plateforme.", -1)),
          _createVNode(_unref(Button), {
            "as-child": "",
            variant: "secondary",
            class: "w-5/6 md:w-1/4 font-bold"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("a", { href: "#contact" }, "En savoir plus", -1)
            ])),
            _: 1
          }),
          _createVNode(_unref(Button), {
            class: "w-5/6 md:w-1/4 font-bold group/arrow",
            onClick: goToUserTypeSelection
          }, {
            default: _withCtx(() => [
              _cache[7] || (_cache[7] = _createTextVNode(" Commencer ")),
              _createVNode(_unref(ArrowRight), { class: "size-5 ml-2 group-hover/arrow:translate-x-1 transition-transform" })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})